import styled from "@emotion/styled";
import { DSButton } from "@hundred5/design-system";
import { Trans } from "@lingui/react/macro";
import * as Sentry from "@sentry/browser";
import { ErrorPage } from "../error-page";

export function ErrorHandler() {
  const email = (
    <a href="mailto:support@hire.toggl.com">support@hire.toggl.com</a>
  );

  return (
    <ErrorPage
      message={
        <Trans>
          Something went wrong. Please reload the page or contact us at {email}
        </Trans>
      }
      content={
        <Content>
          <DSButton onClick={() => Sentry.showReportDialog()}>
            <Trans>Send feedback</Trans>
          </DSButton>
          <DSButton onClick={() => window.location.reload()}>
            <Trans>Reload app</Trans>
          </DSButton>
        </Content>
      }
    />
  );
}

//region Styles
const Content = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-flow: wrap;
`;
//endregion
